module.exports = __webpack_public_path__ + "assets/img/radar.fa19d8b7.png";